import { List } from 'immutable';
import React from 'react';
import { Action, async, mkWidget, Widget } from 'widgets-for-react';
import { RegionSwitchState, Selector } from '../regionSwitchState.mod';
import { renderRegionSwitcherContainer } from './regionSwitchContainer';


export const regionSwitchWidget: (props: RegionSwitchState) => Widget<Action<RegionSwitchState>> = (
  props
) =>
    mkWidget({
      run: (setState: (_: Action<RegionSwitchState>) => void) => {

      const toggleOpenClose = (e: React.MouseEvent<HTMLElement>): void =>  {
        setState((previousState) => {
          const newProps = {
            ...props,
            closed: !previousState.closed
          }
          return newProps;
        })
      }

      const selectorChange = (e: React.MouseEvent<HTMLElement>, index: number): void => {
        if(index >= 0 && props.selectors.kind == 'loaded' && props.selectors.value.get(index) != null){
          setState((previousState) => {
            const newProps = {
              ...props,
              currentSelectorIndex: index
            }
            return newProps;
          })
        }
      }

      return (
        <></>
        // <div className='header'>
        //   {async<List<Selector>>()(props.selectors).run((res) =>
        //     setState((previousState) => {
        //       const updatedState = res(props.selectors)
        //       return {
        //         ...props,
        //         selectors: updatedState
        //       }
        //     })
        //   )}
        //   {
        //     props.selectors.kind == 'loaded' && (
        //       !props.closed ? 
        //         <div>
        //         <button onClick={toggleOpenClose}> X </button>
        //         { props.title && (
        //           <div>
        //            {props.title} 
        //           </div>
  
        //         )
        //         }
        //         { props.description && (
        //           <div>
        //             {props.description}
        //           </div>
        //         )
        //         }
        //         <div>
        //           {/* container */}
        //           {renderRegionSwitcherContainer({selectorChange, selectors: props.selectors.value, color: props.color ? props.color : 'white', currentSelectorIndex: props.currentSelectorIndex }) }
        //         </div>
        //       </div>
        //       :
        //         <div>
        //           {/* Closed */}
        //           <button onClick={toggleOpenClose}>FrieslandCampina {props.siteLanguage}</button>
        //         </div>
        //     )
        //   }
        // </div>
      );
    }
  })

  


